import styled from 'styled-components'
import { MOBILE_BREAKPOINT_PX } from 'utils/mobileLayout'

export const EmbeddedSelectorTriggerButton = styled.button<{
  $collapsed: boolean
}>`
  display: flex;
  width: ${({ $collapsed }) => ($collapsed ? '2rem' : '100%')};
  height: 2rem;
  align-items: center;
  gap: 0.5rem;
  overflow: hidden;
  padding: ${({ $collapsed }) => ($collapsed ? '0' : '0 0.5rem 0 0')};
  border: none;
  border-radius: var(--radius);
  background-color: transparent;
  color: var(--foreground);
  cursor: pointer;
  text-align: left;

  &:hover,
  &[data-state='open'] {
    background-color: var(--accent);
  }

  &:focus-visible {
    outline: 2px solid var(--ring);
    outline-offset: -2px;
  }
`

export const EmbeddedSelectorIcon = styled.span`
  display: inline-flex;
  width: 2rem;
  height: 2rem;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--border);
  border-radius: var(--radius);
  color: var(--foreground);
`

export const EmbeddedSelectorLabels = styled.span<{ $collapsed: boolean }>`
  display: flex;
  min-width: 0;
  flex: 1 1 auto;
  flex-direction: column;
  opacity: ${({ $collapsed }) => ($collapsed ? 0 : 1)};
  transition: opacity 0.15s ease;
`

export const EmbeddedSelectorChevron = styled.span<{ $collapsed: boolean }>`
  display: inline-flex;
  flex-shrink: 0;
  color: var(--muted-foreground);
  opacity: ${({ $collapsed }) => ($collapsed ? 0 : 1)};
  transition: opacity 0.15s ease;
`

export const EmbeddedSubDropdownTrigger = styled.button`
  display: flex;
  width: 100%;
  height: 2.25rem;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  padding: 0 0.75rem;
  border: 1px solid var(--input);
  border-radius: var(--radius);
  background-color: transparent;
  color: var(--muted-foreground);
  font-size: 0.75rem;
  cursor: pointer;
  text-align: left;

  &:hover,
  &[data-state='open'] {
    background-color: var(--accent);
    color: var(--accent-foreground);
  }
`

export const EmbeddedSubDropdownLabel = styled.span`
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const EmbeddedSubDropdownContent = styled.div`
  margin-top: 0.5rem;
  max-height: 16rem;
  overflow-y: auto;
  border: 1px solid var(--border);
  border-radius: var(--radius);
  background-color: var(--background);
  padding: 0.25rem;
`

export const EmbeddedSubDropdownSearch = styled.input`
  width: 100%;
  margin-bottom: 0.25rem;
  padding: 0.5rem;
  border: 1px solid var(--input);
  border-radius: calc(var(--radius) - 2px);
  background-color: transparent;
  color: var(--foreground);
  font-size: 1rem;
  outline: none;

  @media (min-width: ${MOBILE_BREAKPOINT_PX}px) {
    font-size: 0.75rem;
  }

  &::placeholder {
    color: var(--muted-foreground);
  }

  &:focus {
    border-color: var(--ring);
  }
`

export const EmbeddedSubDropdownRow = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 0.25rem;
  border-radius: calc(var(--radius) - 2px);

  &:hover {
    background-color: var(--accent);
  }
`

export const EmbeddedSubDropdownItemLabel = styled.span`
  display: block;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: left;
`

export const EmbeddedSubDropdownActionLabel = styled.span`
  flex: 1 1 auto;
  min-width: 0;
  text-align: left;
`
